module.exports = __webpack_public_path__ + "img/eleitoral.addc3177.png";